module.exports = __webpack_public_path__ + "static/img/img_8.990d2ea2.png";